// import React, { useState } from "react";
// import { useDispatch, useSelector } from 'react-redux'
// import { useParams, Link, useNavigate } from 'react-router-dom'
// import { v4 as uuidv4 } from 'uuid';

// import { loadStripe } from "@stripe/stripe-js";
// import {
//     Elements,
//     CardElement,
//     useStripe,
//     useElements,
// } from "@stripe/react-stripe-js";
// import axios from "axios";

// import { createSubscription } from "../../features/contractSlice"

// const stripePromise = loadStripe(
//     process.env.REACT_APP_PUBLIC_STRIPE_PUBLISHABLE_KEY
// );

// const CheckoutForm = () => {
//     const navigate = useNavigate()
//     const dispatch = useDispatch()
//     const { id } = useParams()

//     const { email, idToken } = useSelector((state) => state.auth);

//     const stripe = useStripe();
//     const elements = useElements();

//     const [couponCode, setCouponCode] = useState("");
//     const [error, setError] = useState(null);
//     const [processing, setProcessing] = useState(false);
//     const [succeeded, setSucceeded] = useState(false);

//     const handleSubmit = async (e) => {
//         e.preventDefault()

//         setProcessing(true);

//         if (!stripe || !elements) {
//             return;
//         }

//         let priceId, amount, subType

//         switch (id) {
//             case "annual":
//                 priceId = process.env.REACT_APP_STRIPE_RECURRING_ANNUAL_PRICE_ID
//                 amount = 99.99
//                 subType = "annual"
//                 break;
//             case "monthly":
//                 priceId = process.env.REACT_APP_STRIPE_RECURRING_MONTHLY_PRICE_ID
//                 amount = 9.99
//                 subType = "monthly"
//                 break;
//             default:
//                 break
//         }

//         try {
//             // First create a PaymentMethod
//             const { paymentMethod, error: paymentMethodError } = await stripe.createPaymentMethod({
//                 type: 'card',
//                 card: elements.getElement(CardElement),
//                 billing_details: {
//                     email: email,
//                 },
//             });

//             if (paymentMethodError) {
//                 setError(`Payment method failed: ${paymentMethodError.message}`);
//                 setProcessing(false);
//                 return;
//             }

//             // Create the subscription on the server
//             const config = {
//                 "headers": {
//                     "Authorization": idToken
//                 }
//             }

//             const url = `${process.env.REACT_APP_API_BASE_URL}/stripepaymentintent`
//             const data = {
//                 email: email,
//                 priceId: priceId,
//                 paymentMethodId: paymentMethod.id,
//                 discountCode: couponCode.trim() || null  // Include coupon code if provided
//             }
//             console.log("data", data)

//             const response = await axios.post(url, data, config);

//             const { subscriptionId, clientSecret, currentPeriodEnd } = response.data;

//             // Confirm the subscription with the card details
//             // const result = await stripe.confirmCardPayment(clientSecret, {
//             //     payment_method: {
//             //         card: elements.getElement(CardElement),
//             //         billing_details: {
//             //             email: email,
//             //         },
//             //     },
//             // });

//             // Confirm the subscription with the card details
//             const result = await stripe.confirmCardPayment(clientSecret, {
//                 payment_method: paymentMethod.id  // Use the created payment method
//             });

//             if (result.error) {
//                 setError(`Payment failed: ${result.error.message}`);
//                 setProcessing(false);
//             } else {
//                 setError(null);
//                 setSucceeded(true);
//                 setProcessing(false);

//                 const data = {
//                     subscription_id: uuidv4(),
//                     realtor_email: email,
//                     stripe_subscription_id: subscriptionId,
//                     sub_type: subType,
//                     sub_amount: amount,
//                     sub_payment_status: "paid",
//                     sub_expiry_date: currentPeriodEnd
//                 }

//                 //Dont save Subscription in DB

//                 // dispatch(createSubscription({ data, idToken }))
//                 navigate("/sub")
//             }
//         } catch (err) {
//             setError("Failed to create subscription: " + err.message);
//             setProcessing(false);
//         }
//     }

//     return (
//         <div className='min-h-64 px-4 py-6'>
//             <div>
//                 <button className='w-[150px] h-[36px] bg-gray-500 hover:bg-gray-600 text-white rounded-lg text-center text-sm'>
//                     <Link to={"/sub/"}>Go Back</Link>
//                 </button>

//                 <div className='text-center text-xl mb-5'>
//                     You are signing up for recurring <span className="font-bold uppercase">{id}</span> subscription
//                 </div>
//                 <div className="">
//                     <p>Once you subscribe, you can cancel anytime before your current subscription ends</p>
//                     <p>If you forget to cancel, payment will be deducted for the next cycle (<span className="font-bold uppercase">{id}</span>) and there will be no  refund</p> </div>
//             </div>
//             <div className="mt-5 border rounded p-5">
//                 <div>Subscriber Email: <span className="font-bold">{email}</span></div>
//                 <form className="mt-2" onSubmit={handleSubmit}>
//                     {/* Add coupon code input */}
//                     <div className="mb-4">
//                         <label className="block text-sm font-medium text-gray-700 mb-1">Coupon Code (Optional)</label>
//                         <input
//                             type="text"
//                             value={couponCode}
//                             onChange={(e) => setCouponCode(e.target.value)}
//                             className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:border-indigo-300"
//                             placeholder="Enter coupon code if you have one"
//                             disabled={processing}
//                         />
//                     </div>

//                     <CardElement />
//                     {error && <div className="text-red-500">{error}</div>}
//                     {succeeded && <div className="text-green-600 italic">Subscription succeeded!</div>}
//                     <button
//                         disabled={processing || !stripe}
//                         className="mt-4 align-middle select-none font-sans font-bold text-center uppercase transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none text-xs py-3 px-6 rounded-lg bg-gray-900 text-white shadow-md shadow-gray-900/10 hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none"
//                     >
//                         {processing ? "Processing..." : "Subscribe"}
//                     </button>
//                 </form>
//                 <div className="mt-2 text-sm italic font-semibold">Contract To Keys does NOT store Credit Card information. Payment is processed by Stripe</div>
//             </div>
//         </div>
//     )
// }

// const PaymentCheckout = () => {
//     return (
//         <Elements stripe={stripePromise}>
//             <CheckoutForm />
//         </Elements>
//     );
// }

// export default PaymentCheckout

import React, { useState } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { useParams, Link, useNavigate } from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid';

import { loadStripe } from "@stripe/stripe-js";
import {
    Elements,
    CardElement,
    useStripe,
    useElements,
} from "@stripe/react-stripe-js";
import axios from "axios";

import { createSubscription } from "../../features/contractSlice"

const stripePromise = loadStripe(
    process.env.REACT_APP_PUBLIC_STRIPE_PUBLISHABLE_KEY
);

// Custom styling for the CardElement
const cardElementOptions = {
    style: {
        base: {
            fontSize: '16px',
            color: '#424770',
            '::placeholder': {
                color: '#aab7c4',
            },
        },
        invalid: {
            color: '#9e2146',
        },
    },
};

const CheckoutForm = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { id } = useParams()

    const { email, idToken } = useSelector((state) => state.auth);

    const stripe = useStripe();
    const elements = useElements();

    const [couponCode, setCouponCode] = useState("");
    const [error, setError] = useState(null);
    const [processing, setProcessing] = useState(false);
    const [succeeded, setSucceeded] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault()

        setProcessing(true);

        if (!stripe || !elements) {
            return;
        }

        let priceId, amount, subType

        switch (id) {
            case "annual":
                priceId = process.env.REACT_APP_STRIPE_RECURRING_ANNUAL_PRICE_ID
                amount = 99.99
                subType = "annual"
                break;
            case "monthly":
                priceId = process.env.REACT_APP_STRIPE_RECURRING_MONTHLY_PRICE_ID
                amount = 9.99
                subType = "monthly"
                break;
            default:
                break
        }

        try {
            // First create a PaymentMethod
            const { paymentMethod, error: paymentMethodError } = await stripe.createPaymentMethod({
                type: 'card',
                card: elements.getElement(CardElement),
                billing_details: {
                    email: email,
                },
            });

            if (paymentMethodError) {
                setError(`Payment method failed: ${paymentMethodError.message}`);
                setProcessing(false);
                return;
            }

            // Create the subscription on the server
            const config = {
                "headers": {
                    "Authorization": idToken
                }
            }

            const url = `${process.env.REACT_APP_API_BASE_URL}/stripepaymentintent`
            const data = {
                email: email,
                priceId: priceId,
                paymentMethodId: paymentMethod.id,
                discountCode: couponCode.trim() ? couponCode.trim().toUpperCase() : null  // Convert to uppercase if provided
            }

            const response = await axios.post(url, data, config);

            const { subscriptionId, clientSecret, currentPeriodEnd } = response.data;

            // Confirm the subscription with the card details
            const result = await stripe.confirmCardPayment(clientSecret, {
                payment_method: paymentMethod.id  // Use the created payment method
            });

            if (result.error) {
                setError(`Payment failed: ${result.error.message}`);
                setProcessing(false);
            } else {
                setError(null);
                setSucceeded(true);
                setProcessing(false);

                const data = {
                    subscription_id: uuidv4(),
                    realtor_email: email,
                    stripe_subscription_id: subscriptionId,
                    sub_type: subType,
                    sub_amount: amount,
                    sub_payment_status: "paid",
                    sub_expiry_date: currentPeriodEnd
                }

                //Dont save Subscription in DB
                // dispatch(createSubscription({ data, idToken }))
                navigate("/sub")
            }
        } catch (err) {
            if (err.response && err.response.data) {
                // If there's a specific error message from the API
                if (err.response.data.message) {
                    setError(err.response.data.message);
                }
                // If there's an error object with details about the coupon
                else if (err.response.data.error && err.response.data.error.includes('coupon')) {
                    setError(err.response.data.error);
                }
                // Generic API error
                else {
                    setError("Failed to process payment: " + (err.response.data.error || "Unknown error"));
                }
            } else {
                // Network or other errors
                setError("Failed to create subscription: " + err.message);
            }
            setProcessing(false);
        }
    }

    return (
        <div className='max-w-2xl mx-auto min-h-64 px-4 py-8'>
            <div className="flex items-center mb-6">
                <Link
                    to="/sub/"
                    className="flex items-center text-blue-600 hover:text-blue-800 transition-colors"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M9.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L7.414 9H15a1 1 0 110 2H7.414l2.293 2.293a1 1 0 010 1.414z" clipRule="evenodd" />
                    </svg>
                    Back to Subscriptions
                </Link>
            </div>

            <div className="bg-white rounded-lg shadow-md overflow-hidden">
                <div className="bg-blue-50 p-6 border-b border-blue-100">
                    <h1 className="text-2xl font-bold text-center text-gray-800">
                        {id === "annual" ? "Annual" : "Monthly"} Subscription
                    </h1>
                    <div className="text-center text-gray-600 mt-2">
                        {id === "annual" ? "$99.99 per year" : "$9.99 per month"}
                    </div>
                </div>

                <div className="p-6">
                    <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
                        <div className="flex">
                            <div className="flex-shrink-0">
                                <svg className="h-5 w-5 text-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2h-1V9a1 1 0 00-1-1z" clipRule="evenodd" />
                                </svg>
                            </div>
                            <div className="ml-3">
                                <p className="text-sm text-yellow-700">
                                    You can cancel anytime before your current subscription ends. If you forget to cancel, payment will be deducted for the next cycle and there will be no refund.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="mb-6">
                        <div className="flex items-center mb-2">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-500 mr-2" viewBox="0 0 20 20" fill="currentColor">
                                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                            </svg>
                            <span className="text-gray-700">Subscriber Email:</span>
                            <span className="font-semibold ml-2">{email}</span>
                        </div>
                    </div>

                    <form onSubmit={handleSubmit}>
                        <div className="mb-6">
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Coupon Code <span className="text-gray-500 text-xs">(Optional)</span>
                            </label>
                            <input
                                type="text"
                                value={couponCode}
                                onChange={(e) => setCouponCode(e.target.value)}
                                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                placeholder="Enter coupon code if you have one"
                                disabled={processing}
                            />
                        </div>

                        <div className="mb-6">
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Card Details
                            </label>
                            <div className="p-4 border border-gray-300 rounded-md focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-blue-500">
                                <CardElement options={cardElementOptions} />
                            </div>
                        </div>

                        {error && (
                            <div className="mb-4 bg-red-50 border-l-4 border-red-400 p-4">
                                <div className="flex">
                                    <div className="flex-shrink-0">
                                        <svg className="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                                        </svg>
                                    </div>
                                    <div className="ml-3">
                                        <p className="text-sm text-red-700">{error}</p>
                                    </div>
                                </div>
                            </div>
                        )}

                        {succeeded && (
                            <div className="mb-4 bg-green-50 border-l-4 border-green-400 p-4">
                                <div className="flex">
                                    <div className="flex-shrink-0">
                                        <svg className="h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                        </svg>
                                    </div>
                                    <div className="ml-3">
                                        <p className="text-sm text-green-700">Subscription succeeded!</p>
                                    </div>
                                </div>
                            </div>
                        )}

                        <button
                            disabled={processing || !stripe}
                            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-4 rounded-md shadow-sm transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            {processing ? (
                                <span className="flex items-center justify-center">
                                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                    Processing...
                                </span>
                            ) : (
                                "Subscribe Now"
                            )}
                        </button>
                    </form>

                    <div className="mt-6 text-center text-xs text-gray-500 flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                        </svg>
                        Contract To Keys does NOT store Credit Card information. Payment is processed securely by Stripe.
                    </div>
                </div>
            </div>
        </div>
    )
}

const PaymentCheckout = () => {
    return (
        <Elements stripe={stripePromise}>
            <CheckoutForm />
        </Elements>
    );
}

export default PaymentCheckout
